/* the kinds of projects */

export enum ProjectType {
  Library,
  Simulation,
  BatchSimulation,
  None
}

/** convert blob type to string */
export function stringOfProjectType(type: ProjectType) {

  switch (type) {
    case ProjectType.Library:         return 'library';
    case ProjectType.Simulation:      return 'simulation';
    case ProjectType.BatchSimulation: return 'batch_simulation';
    case ProjectType.None:            return 'none';
  }

  return 'none';
}

/** convert blob type string to blob type */
export function projectTypeOfString(text: string) {

  text = text.toLowerCase().trim();

  switch (text) {
    case 'library':          return ProjectType.Library;
    case 'simulation':       return ProjectType.Simulation;
    case 'batch_simulation': return ProjectType.BatchSimulation;
    case 'none':             return ProjectType.None;
  }

  return ProjectType.None;
}
